<template>
  <div>
    <c-form @submit.prevent="submit">
      <c-title>Passwort ändern</c-title>

      <div class="intro-text">
        <p>
          Zum Schutz Ihrer Daten haben wir unsere Passwort-Richtlinien aktualisiert. 
          Bitte geben Sie Ihr aktuelles Passwort ein und wählen Sie anschließend ein neues Passwort. 
          Das neue Passwort darf nicht identisch mit dem alten sein.
        </p>
      </div>

      <c-form-input
        id="currentPassword"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.currentPassword.required
        }]"
        :has-error="$v.currentPassword.$error"
        v-model="currentPassword"
        aria-required="true"
        autocomplete="current-password"
        label="Aktuelles Passwort"
        placeholder="Bitte aktuelles Passwort eingeben"
        type="password"
      />

      <c-form-input
        id="newPassword"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.newPassword.required
        }, {
          message: 'Das neue Passwort entspricht nicht den Sicherheitsanforderungen.',
          show: !$v.newPassword.strongPassword
        }, {
          message: 'Das neue Passwort darf nicht identisch mit dem aktuellen Passwort sein.',
          show: !$v.newPassword.differentFromCurrent
        }]"
        :has-error="$v.newPassword.$error"
        v-model="newPassword"
        aria-required="true"
        autocomplete="new-password"
        label="Neues Passwort"
        placeholder="Neues Passwort eingeben"
        type="password"
      />

      <c-password-strength-indicator
        :password="newPassword"
        :show-requirements="newPassword.length > 0"
      />

      <c-form-input
        id="confirmPassword"
        :errors="[{
          message: 'Dieses Feld ist erforderlich.',
          show: !$v.confirmPassword.required
        }, {
          message: 'Die Passwörter stimmen nicht überein.',
          show: !$v.confirmPassword.sameAsPassword
        }]"
        :has-error="$v.confirmPassword.$error"
        v-model="confirmPassword"
        aria-required="true"
        autocomplete="new-password"
        label="Neues Passwort bestätigen"
        placeholder="Neues Passwort erneut eingeben"
        type="password"
      />

      <c-button :busy="changePasswordStatus === $config.status.LOADING">
        Passwort ändern
      </c-button>
    </c-form>
  </div>
</template>

<script>
import CButton from '@/components/CButton'
import CForm from '@/components/form/CForm'
import CFormInput from '@/components/form/CFormInput'
import CPasswordStrengthIndicator from '@/components/form/CPasswordStrengthIndicator'
import CTitle from '@/components/CTitle'

import handleRequestError from '@/functions/handleRequestError'
import { strongPassword } from '@/functions/validators'
import { required, sameAs } from 'vuelidate/lib/validators'
import { helpers } from 'vuelidate/lib/validators'

export default {
  name: 'VChangePassword',

  components: {
    CButton,
    CForm,
    CFormInput,
    CPasswordStrengthIndicator,
    CTitle
  },

  data () {
    return {
      changePasswordStatus: this.$config.status.IDLE,
      currentPassword: '',
      newPassword: '',
      confirmPassword: ''
    }
  },

  validations: {
    currentPassword: {
      required
    },
    newPassword: {
      required,
      strongPassword,
      differentFromCurrent: helpers.withParams(
        { type: 'differentFromCurrent' },
        function (value) {
          return !helpers.req(value) || value !== this.currentPassword
        }
      )
    },
    confirmPassword: {
      required,
      sameAsPassword: sameAs('newPassword')
    }
  },

  methods: {
    submit () {
      this.$v.$touch()

      if (this.$v.$invalid) {
        this.$store.commit('notifications/add', {
          text: 'Bitte füllen Sie alle Felder korrekt aus.',
          type: 'error'
        })
        return
      }

      this.changePasswordStatus = this.$config.status.LOADING

      this.$api.patch('auth/change-password/', {
        current_password: this.currentPassword,
        new_password: this.newPassword
      })
        .then(response => {
          this.changePasswordStatus = this.$config.status.SUCCESS
          
          // Navigate to success page
          this.$router.push({ name: 'password-change-success' })
        })
        .catch(error => {
          this.changePasswordStatus = this.$config.status.ERROR
          
          if (error.response && error.response.status === 400) {
            const errorData = error.response.data
            if (errorData.current_password) {
              this.$store.commit('notifications/add', {
                text: 'Das aktuelle Passwort ist nicht korrekt.',
                type: 'error'
              })
            } else if (errorData.new_password) {
              this.$store.commit('notifications/add', {
                text: 'Das neue Passwort entspricht nicht den Sicherheitsanforderungen.',
                type: 'error'
              })
            } else {
              handleRequestError({
                error,
                fallback: 'Es ist ein Fehler beim Ändern des Passworts aufgetreten. Bitte versuchen Sie es später erneut.'
              })
            }
          } else {
            handleRequestError({
              error,
              fallback: 'Es ist ein Fehler beim Ändern des Passworts aufgetreten. Bitte versuchen Sie es später erneut.'
            })
          }
        })
    }
  }
}
</script>

<style scoped>
.intro-text {
  background-color: #e8f4fd;
  border: 1px solid #bee5eb;
  border-radius: 4px;
  padding: 16px;
  margin-bottom: 20px;
}

.intro-text p {
  margin: 0;
  color: #0c5460;
  font-size: 14px;
  line-height: 1.5;
}
</style>
